<template>
  <div class="column">
    <div class="card tilebox-one">
      <div class="card-body">
        <i class="dripicons-basket float-end text-muted"></i>
        <h6 class="text-muted text-uppercase mt-0">Efficiency Rating</h6>
        <h2 class="m-b-20"><animated-number v-model="currentEff" />%</h2>
        <span class="badge" :class="{'bg-primary' : previousEff > 0, 'bg-alert' : previousEff <= 0}"><animated-number v-model="previousEff" />% </span> <span class="text-muted">From previous</span>
      </div>
    </div>
  </div>
</template>
<script>
import AnimatedNumber from '../../../../components/AnimatedNumber.vue'

export default {
  components: {
    AnimatedNumber
  },
  props: {
    ratingData: {
      billingData: {},
      nonBillableData: {},
      timelogData: {},
      accuracyData: {}
    },
    user: {},
    value: 0
  },
  data() {
    return {
      efficiencyData: {
        current: {},
        previous: {}
      },
      syncTimeout: null
    }
  },
  watch: {
    'currentEff'(value) {
      this.$emit('input', Math.round(this.currentEff))
    },
  },
  mounted() {
  },
  methods: {
    calcPercent(a, b) {
      return Math.round((a / b) * 1000) /10
    },

  },
  computed: {

    /*
    * ESTE ES EL CALCULO FINAL QUE SU RESULTADO FUNCIONA DE LA SIGUIENTE MANERA(BILLING ACTUAL - NONBILLING ACTUAL + TIMELOG ACTUAL)
    */
    currentEff() {
      return this.billingPercent -
          this.nonBillablePercent +
          this.timelogPercent +
          this.accuracyPercent
    },

    /*
    * ESTE ES EL CALCULO FINAL QUE SU RESULTADO FUNCIONA DE LA SIGUIENTE MANERA(BILLING PREVIO - NONBILLING PREVIO + TIMELOG PREVIO)
    */
    previousEff() {
      return this.previousBillingPercent -
          this.previousNonBillablePercent +
          this.previousTimelogPercent +
          this.accuracyPreviousPercent
    },

    /*
    * te devuelve los billing de las metricas del usuario dividido en 100, userbilling/100
    */
    userBillingWeight() {
      return this.user.metrics.filter(p => p.key == 'billing')[0].weight / 100
    },

    /*
    * te devuelve los nonbilling de las metricas del usuario dividido en 100, userNonBillable/100
    */
    userNonBillableWeight() {
      return this.user.metrics.filter(p => p.key == 'nonbillable')[0].weight / 100
    },

    /*
    * te devuelve el porcentaje del timelog predeterminado del usuario(por default es 30) de las metricas del usuario dividido en 100, timelog/100
    */
    timelogWeight() {
      return this.user.metrics.filter(p => p.key == 'timelog')[0].weight / 100
    },

    accuracyWeight() {
      return this.user.metrics.filter(p => p.key == 'accuracy')[0].weight / 100
    },

    /*
    * te devuelve el porcentaje de los datos billing actuales de la base de datos por el userBillingWeight, (datos billing ACTUAL x userBillingWeight)
    */
    billingPercent() {
      let percent = this.ratingData && this.ratingData.billingData ? this.ratingData.billingData.billingPercent : 0
      return percent * this.userBillingWeight
    },

    /*
    * te devuelve el porcentaje de los datos nonBilling actuales de la base de datos por el userNonBillingWeight, (datos nonbilling ACTUAL x userNonBillingWeight)
    * Edit: el metodo isFinite se usa para ver si el valor es NULL, NaN, Undefined o Infinity que me devuelva true de lo contrario false y si es false tirame un 0
    */
    nonBillablePercent() {
      let current = 0
      let bill = 0

      setTimeout(() => {
            if (this.ratingData.nonBillableData !== null && this.ratingData.billingData.previous !== null) {
              current = isFinite(this.ratingData.nonBillableData.nonBillableCurrent) ? this.ratingData.nonBillableData.nonBillableCurrent : 0
              bill = isFinite(this.ratingData.billingData.billingPercent) ? this.ratingData.billingData.billingPercent : 0
            }
      }, 2000)
      return isFinite(this.calcPercent(current, bill) * this.userNonBillableWeight) ? (this.calcPercent(current, bill) * this.userNonBillableWeight) : 0
    },


    /*
    * te devuelve el porcentaje de los datos timelog actuales de la base de datos por el timelogWeight, (datos timelog ACTUAL x timelogWeight)
    */
    timelogPercent() {
      let current = this.ratingData && this.ratingData.timelogData ? this.ratingData.timelogData.timelogPercent : 0
      return (current * this.timelogWeight) | 0
    },

    accuracyPercent(){
      let current = this.ratingData && this.ratingData.accuracyData ? this.ratingData.accuracyData.accuracyData.current : 0
      return (current * this.accuracyWeight);
    },

    /*
    * te devuelve el porcentaje de los datos billing previos(mes pasado) de la base de datos por el userBillingWeight, (datos billing PREVIOS x userBillingWeight)
    */
    previousBillingPercent() {
      // let percent = isFinite(this.ratingData.billingData) ? this.ratingData.billingData.previousBillingPercent : 0
      return 0
    },

    /*
    * te devuelve el porcentaje de los datos nonBilling previos(mes pasado) de la base de datos por el userNonBillingWeight, (datos nonbilling PREVIOS x userNonBillingWeight)
    * Edit: el metodo isFinite se usa para ver si el valor es NULL, NaN, Undefined o Infinity que me devuelva true de lo contrario false y si es false tirame un 0
    */
    previousNonBillablePercent() {
      let previous = 0
      let bill = 0
      setTimeout(() => {
        if (this.ratingData.nonBillableData !== null && this.ratingData.billingData.previous !== null){
          previous = !isFinite(this.ratingData.nonBillableData) ? this.ratingData.billingData.previousNonBillablePercent : 0
          bill = !isFinite(this.ratingData.billingData.previous) ? this.ratingData.billingData.previous : 0
        }
      }, 2000)
      return (this.calcPercent(previous, bill) * this.userNonBillableWeight) | 0
    },

    /*
    * te devuelve el porcentaje de los datos timelog previos(mes pasado) de la base de datos por el timelogWeight, (datos timelog PREVIOS x timelogWeight)
    */
    previousTimelogPercent() {
      let previous = this.ratingData && this.ratingData.timelogData ? this.ratingData.timelogData.previousTimelogPercent : 0
      return (previous * this.timelogWeight) | 0
    },

    accuracyPreviousPercent(){
      let previous = this.ratingData && this.ratingData.accuracyData ? this.ratingData.accuracyData.accuracyData.previous : 0
      return (previous *  this.accuracyWeight);
    },

  }
}
</script>